import React from "react";
import withRouter from "@tvg/utils/withCustomRouter";
import { get } from "lodash";

import mediator from "@tvg/mediator";
import ButtonDefault from "@tvg/atomic-ui/_atom/Buttons/default";
import { isFDR } from "@tvg/utils/generalUtils";

import Icon from "../../_static/Icons";
import { arrowBack } from "../../_static/Icons/icons";
import buildColor from "../../_static/ColorPalette";

import { BackButtonContainer, BackButtonText } from "./styled-compnents";

export const BackButtonComponent = ({ history, qaLabel }) => (
  <BackButtonContainer data-qa-label={qaLabel}>
    <ButtonDefault
      onClick={() => {
        let slug = get(history, "location.state.pageOrigin", "promos");
        const isRnGoBack = get(history, "location.search", "").includes(
          "showBackBtn"
        );

        if (slug === "promos/") {
          slug = "promos";
        }

        if (isRnGoBack || isFDR()) {
          history.push("/promos");
        } else {
          history.goBack();
        }

        mediator.base.dispatch({
          type: "UPDATE_PROMOS_CONTENT",
          payload: { slug }
        });
      }}
      qaLabel={`${qaLabel}Action`}
    >
      <Icon
        icon={arrowBack}
        size={16}
        color={buildColor("grey", "900")}
        qaLabel={`${qaLabel}Icon`}
      />
      <BackButtonText data-qa-label={`${qaLabel}Text`}>Back</BackButtonText>
    </ButtonDefault>
  </BackButtonContainer>
);

BackButtonComponent.defaultProps = {
  qaLabel: "backButton"
};

export default withRouter(BackButtonComponent);
